

















































import { Component, Vue } from 'vue-property-decorator';
import ProgressBar from 'vue-simple-progress'

import { APP_CONFIG } from '@/config/app-config';

import commonService from '@/services/common-services';

import Rating from '@/shared/components/Rating.vue';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        'rate': Rating,
        ProgressBar
    }
})
export default class WalletInfo extends Vue {
    private eventEmit = {
        eventShowTradeHistories: 'eventShowTradeHistories'
    };

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get nextLevelDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === ((this.customerInfo.LevelID || 1) + 1) );
    }

    get colorBar() {
        const percentLevel = this.customerInfo.TotalTransaction / (this.nextLevelDetail ? this.nextLevelDetail.FromMoney : this.customerInfo.TotalTransaction)
        if(percentLevel < 0.3) {
            return '#d9534f';
        } else if (percentLevel < 0.5) {
            return '#dc720f';
        } else if (percentLevel < 0.8) {
            return '#dfe220';
        } else {
            return '#74e220';
        }
    }

    get textBar() {
        const needPoint = (this.nextLevelDetail ? this.nextLevelDetail.FromMoney : this.customerInfo.TotalTransaction) - this.customerInfo.TotalTransaction;
        return this.nextLevelDetail && needPoint > 0 ? `Cần tích lũy thêm ${formatNumber(needPoint, '0,0')}` : '';
    }

    private async created() {
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async onShowTradeHistories() {
        this.$emit(this.eventEmit.eventShowTradeHistories, true);
    }
}
